function Icon(props) {
  const { type, width, height, color, onClick } = props;

  switch (type) {
    case "job-section-search":
      return (
        <svg
          className="mx-1"
          width="16"
          height="16"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 16.5L13.5834 13.5833M15.6667 8.58333C15.6667 12.4954 12.4954 15.6667 8.58333 15.6667C4.67132 15.6667 1.5 12.4954 1.5 8.58333C1.5 4.67132 4.67132 1.5 8.58333 1.5C12.4954 1.5 15.6667 4.67132 15.6667 8.58333Z"
            stroke="#667085"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "hire-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 232 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 0C6.26801 0 0 6.26801 0 14V86C0 93.732 6.26801 100 14 100H217.792C225.524 100 231.792 93.732 231.792 86V14C231.792 6.26801 225.524 0 217.792 0H14ZM76.8786 38.921C80.6031 38.921 83.6223 35.341 83.6223 30.9249C83.6223 26.5087 80.6031 22.9287 76.8786 22.9287C73.1541 22.9287 70.1349 26.5087 70.1349 30.9249C70.1349 35.341 73.1541 38.921 76.8786 38.921ZM136.109 82.6747C130.012 82.6747 125.177 80.9432 121.606 77.4802C118.036 74.0172 116.113 69.0934 115.838 62.7085C115.783 62.1674 115.756 61.4911 115.756 60.6794C115.756 59.8137 115.783 59.1373 115.838 58.6503C116.058 54.5381 116.992 51.021 118.64 48.0991C120.343 45.1231 122.678 42.8505 125.644 41.2814C128.611 39.6581 132.099 38.8465 136.109 38.8465C140.559 38.8465 144.295 39.7663 147.316 41.606C150.338 43.3916 152.617 45.9077 154.156 49.1542C155.694 52.3466 156.463 56.0531 156.463 60.2736V61.978C156.463 62.5191 156.271 62.979 155.886 63.3578C155.501 63.7366 155.007 63.9259 154.403 63.9259H127.045V64.1694V64.5752C127.1 66.4691 127.457 68.2276 128.116 69.8509C128.83 71.42 129.847 72.6916 131.165 73.6655C132.539 74.6395 134.159 75.1265 136.027 75.1265C137.565 75.1265 138.856 74.91 139.9 74.4772C140.944 73.9902 141.795 73.4491 142.454 72.8539C143.114 72.2587 143.581 71.7717 143.855 71.393C144.35 70.7437 144.734 70.3649 145.009 70.2567C145.338 70.0944 145.805 70.0132 146.41 70.0132H153.496C154.046 70.0132 154.485 70.1755 154.815 70.5002C155.199 70.8248 155.364 71.2306 155.309 71.7176C155.254 72.5834 154.787 73.6385 153.908 74.883C153.084 76.1275 151.876 77.3449 150.283 78.5353C148.689 79.7257 146.684 80.7267 144.267 81.5384C141.905 82.2959 139.186 82.6747 136.109 82.6747ZM127.045 57.1082H145.256V56.8647C145.256 54.7545 144.899 52.9148 144.185 51.3456C143.471 49.7224 142.427 48.4779 141.053 47.6121C139.68 46.6923 138.032 46.2323 136.109 46.2323C134.187 46.2323 132.539 46.6923 131.165 47.6121C129.792 48.4779 128.748 49.7224 128.034 51.3456C127.375 52.9148 127.045 54.7545 127.045 56.8647V57.1082ZM88.6855 82.6747C88.1362 82.6747 87.6692 82.4853 87.2847 82.1065C86.9001 81.7278 86.7078 81.2678 86.7078 80.7267V42.4988C86.7078 41.9036 86.9001 41.4167 87.2847 41.0379C87.6692 40.6591 88.1362 40.4697 88.6855 40.4697H95.3601C95.9095 40.4697 96.3764 40.6591 96.761 41.0379C97.2005 41.4167 97.4202 41.9036 97.4202 42.4988V45.8265C98.6837 44.095 100.304 42.7694 102.282 41.8495C104.315 40.9297 106.649 40.4697 109.286 40.4697H112.665C113.269 40.4697 113.736 40.6591 114.066 41.0379C114.45 41.4167 114.642 41.8766 114.642 42.4177V48.2614C114.642 48.8025 114.45 49.2624 114.066 49.6412C113.736 50.02 113.269 50.2094 112.665 50.2094H106.237C103.6 50.2094 101.54 50.9398 100.057 52.4008C98.6288 53.8076 97.9146 55.8096 97.9146 58.4068V80.7267C97.9146 81.2678 97.7223 81.7278 97.3378 82.1065C96.9533 82.4853 96.4588 82.6747 95.8545 82.6747H88.6855ZM173.661 73.2177C173.931 73.4875 174.258 73.6224 174.644 73.6224H177.996C178.42 73.6224 178.748 73.4875 178.979 73.2177C179.249 72.948 179.383 72.6204 179.383 72.2351V60.9634H190.482C190.867 60.9634 191.195 60.8285 191.464 60.5588C191.734 60.289 191.869 59.9422 191.869 59.5183V56.5125C191.869 56.0886 191.734 55.7611 191.464 55.5299C191.195 55.2601 190.867 55.1252 190.482 55.1252H179.383V44.1426C179.383 43.7572 179.249 43.4297 178.979 43.1599C178.748 42.8902 178.42 42.7553 177.996 42.7553H174.644C174.258 42.7553 173.931 42.8902 173.661 43.1599C173.391 43.4297 173.256 43.7572 173.256 44.1426V55.1252H162.158C161.773 55.1252 161.445 55.2601 161.175 55.5299C160.906 55.7611 160.771 56.0886 160.771 56.5125V59.5183C160.771 59.9422 160.906 60.289 161.175 60.5588C161.445 60.8285 161.773 60.9634 162.158 60.9634H173.256V72.2351C173.256 72.6204 173.391 72.948 173.661 73.2177ZM209.167 73.2177C209.437 73.4875 209.764 73.6224 210.15 73.6224H213.502C213.926 73.6224 214.254 73.4875 214.485 73.2177C214.755 72.948 214.89 72.6204 214.89 72.2351V60.9634H225.988C226.373 60.9634 226.701 60.8285 226.971 60.5588C227.24 60.289 227.375 59.9422 227.375 59.5183V56.5125C227.375 56.0886 227.24 55.7611 226.971 55.5299C226.701 55.2601 226.373 55.1252 225.988 55.1252H214.89V44.1426C214.89 43.7572 214.755 43.4297 214.485 43.1599C214.254 42.8902 213.926 42.7553 213.502 42.7553H210.15C209.764 42.7553 209.437 42.8902 209.167 43.1599C208.897 43.4297 208.762 43.7572 208.762 44.1426V55.1252H197.664C197.279 55.1252 196.951 55.2601 196.682 55.5299C196.412 55.7611 196.277 56.0886 196.277 56.5125V59.5183C196.277 59.9422 196.412 60.289 196.682 60.5588C196.951 60.8285 197.279 60.9634 197.664 60.9634H208.762V72.2351C208.762 72.6204 208.897 72.948 209.167 73.2177ZM23.6994 18.4008C23.6994 22.8169 20.6801 26.3969 16.9557 26.3969C13.2312 26.3969 10.2119 22.8169 10.2119 18.4008C10.2119 13.9846 13.2312 10.4046 16.9557 10.4046C20.6801 10.4046 23.6994 13.9846 23.6994 18.4008ZM60.1156 28.131C63.8401 28.131 66.8593 24.551 66.8593 20.1349C66.8593 15.7187 63.8401 12.1387 60.1156 12.1387C56.3911 12.1387 53.3719 15.7187 53.3719 20.1349C53.3719 24.551 56.3911 28.131 60.1156 28.131ZM73.5021 82.8516C72.9566 82.8516 72.493 82.6455 72.1112 82.2332C71.9688 82.0794 71.6576 81.9133 71.3234 81.735C70.7617 81.4351 70.1349 81.1006 70.1349 80.7313L71.2112 43.8911C71.2112 43.4102 71.3385 43.2827 71.593 43.0277C71.6502 42.9704 71.7138 42.9066 71.7839 42.8309C72.1657 42.4187 72.3839 42.3892 72.9294 42.3892H80.3748C80.9748 42.3892 81.5203 42.4187 81.8476 42.8309C82.2294 43.2432 82.2567 43.3021 82.2567 43.8911L83.6223 80.7313C83.6223 81.102 83.0059 81.4376 82.4537 81.7383C82.1285 81.9154 81.8255 82.0804 81.6839 82.2332C81.3567 82.6455 80.893 82.8516 80.293 82.8516H73.5021ZM22.4816 82.8516H12.7514C12.655 82.8516 12.3853 82.7938 12.077 82.5626C11.6916 82.2736 10.5356 81.0212 10.2466 80.2505C10.1519 79.9981 10.2639 75.3682 10.4292 68.5332C10.6677 58.6699 11.0173 44.2147 11.0173 31.6956L11.3063 31.0212L11.5953 30.5395L12.077 30.1541L12.7514 29.7688H22.3853L23.156 29.9615L23.5413 30.2505L24.023 30.8285L24.2157 31.0212L24.4084 31.6956C24.4084 31.6956 25.2408 38.921 25.0482 42.0039C24.8555 45.0867 52.8284 46.2428 52.8284 46.2428L52.6358 31.6956L52.9248 31.1175L53.2138 30.6358L53.6955 30.1541L54.2735 29.8651L55.0442 29.7688H63.9074L64.5818 29.8651L65.0635 30.1541L65.5452 30.5395L65.9306 31.1175L66.1232 31.6956L66.894 79.5761L66.5086 80.9249L65.9306 81.6956L65.6415 82.0809L65.0635 82.5626L64.5818 82.7553L64.1965 82.8516H54.9479L54.4662 82.7553L53.9845 82.5626L53.5992 82.2736L53.2138 81.8882L53.0211 81.5029L52.3468 80.9249L51.9614 79.5761L52.8284 54.7206C41.4581 51.7952 35.2218 51.6826 24.4084 54.7206C24.4084 59.8373 24.5288 63.6614 24.6492 67.4855C24.7697 71.3097 24.8901 75.1338 24.8901 80.2505L24.3121 81.3102L24.1194 81.6956L23.8304 82.0809L23.5413 82.4663L23.156 82.659L22.578 82.8516H22.4816Z"
            fill="#2888F6"
          />
        </svg>
      );
    case "hire-logo-white":
      return (
        <svg
          width="84"
          height="32"
          viewBox="0 0 84 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.92395 0C2.65224 0 0 2.65224 0 5.92395V26.0761C0 29.3478 2.65224 32 5.92395 32H77.5191C80.7908 32 83.443 29.3478 83.443 26.0761V5.92395C83.443 2.65224 80.7908 0 77.5191 0H5.92395ZM40.1532 24.4881C41.2411 25.4456 42.7138 25.9244 44.5716 25.9244C45.5088 25.9244 46.3372 25.8197 47.0569 25.6102C47.7933 25.3858 48.4041 25.109 48.8895 24.7798C49.3748 24.4507 49.743 24.114 49.9941 23.7699C50.2618 23.4258 50.4041 23.1341 50.4208 22.8947C50.4376 22.76 50.3874 22.6478 50.2702 22.558C50.1698 22.4683 50.0359 22.4234 49.8685 22.4234H47.7096C47.5255 22.4234 47.3832 22.4458 47.2828 22.4907C47.1991 22.5206 47.082 22.6254 46.9314 22.8049C46.8477 22.9096 46.7054 23.0443 46.5046 23.2089C46.3037 23.3734 46.0443 23.5231 45.7264 23.6577C45.4084 23.7774 45.0151 23.8373 44.5465 23.8373C43.9774 23.8373 43.4837 23.7026 43.0653 23.4333C42.6636 23.164 42.354 22.8124 42.1364 22.3785C41.9356 21.9297 41.8268 21.4434 41.8101 20.9198V20.8075V20.7402H50.1447C50.3288 20.7402 50.4794 20.6878 50.5966 20.5831C50.7137 20.4784 50.7723 20.3512 50.7723 20.2016V19.7303C50.7723 18.5633 50.538 17.5384 50.0694 16.6557C49.6008 15.758 48.9062 15.0623 47.9857 14.5686C47.0652 14.0599 45.9272 13.8055 44.5716 13.8055C43.3498 13.8055 42.2871 14.03 41.3833 14.4788C40.4796 14.9127 39.7683 15.5411 39.2495 16.364C38.7474 17.1719 38.4628 18.1444 38.3959 19.2815C38.3792 19.4161 38.3708 19.6031 38.3708 19.8425C38.3708 20.0669 38.3792 20.254 38.3959 20.4036C38.4796 22.169 39.0654 23.5305 40.1532 24.4881ZM47.3581 18.8551H41.8101V18.7877C41.8101 18.2042 41.9105 17.6955 42.1113 17.2617C42.3289 16.8128 42.6469 16.4687 43.0653 16.2293C43.4837 15.975 43.9858 15.8478 44.5716 15.8478C45.1573 15.8478 45.6594 15.975 46.0778 16.2293C46.4962 16.4687 46.8142 16.8128 47.0318 17.2617C47.2493 17.6955 47.3581 18.2042 47.3581 18.7877V18.8551ZM29.4269 25.7673C29.5441 25.872 29.6864 25.9244 29.8537 25.9244H32.0378C32.2219 25.9244 32.3725 25.872 32.4897 25.7673C32.6068 25.6626 32.6654 25.5354 32.6654 25.3858V19.2141C32.6654 18.496 32.883 17.9424 33.3181 17.5534C33.77 17.1494 34.3976 16.9475 35.2009 16.9475H37.159C37.3431 16.9475 37.4854 16.8951 37.5858 16.7904C37.703 16.6856 37.7616 16.5585 37.7616 16.4088V14.793C37.7616 14.6434 37.703 14.5162 37.5858 14.4115C37.4854 14.3067 37.3431 14.2544 37.159 14.2544H36.1298C35.3264 14.2544 34.6152 14.3815 33.9959 14.6359C33.3934 14.8902 32.8997 15.2568 32.5148 15.7356V14.8154C32.5148 14.6509 32.4478 14.5162 32.3139 14.4115C32.1968 14.3067 32.0545 14.2544 31.8872 14.2544H29.8537C29.6864 14.2544 29.5441 14.3067 29.4269 14.4115C29.3098 14.5162 29.2512 14.6509 29.2512 14.8154V25.3858C29.2512 25.5354 29.3098 25.6626 29.4269 25.7673ZM57.9426 24.7709C57.791 24.7709 57.6622 24.7228 57.5561 24.6265C57.45 24.5302 57.397 24.4133 57.397 24.2757V20.5589H53.3389C53.1873 20.5589 53.0585 20.5108 52.9524 20.4145C52.8463 20.3182 52.7933 20.1944 52.7933 20.0431V18.357C52.7933 18.2057 52.8463 18.0888 52.9524 18.0063C53.0585 17.91 53.1873 17.8618 53.3389 17.8618H57.397V14.2482C57.397 14.1106 57.45 13.9937 57.5561 13.8974C57.6622 13.8011 57.791 13.753 57.9426 13.753H59.8742C60.0409 13.753 60.1698 13.8011 60.2607 13.8974C60.3668 13.9937 60.4198 14.1106 60.4198 14.2482V17.8618H64.4779C64.6295 17.8618 64.7583 17.91 64.8644 18.0063C64.9705 18.0888 65.0235 18.2057 65.0235 18.357V20.0431C65.0235 20.1944 64.9705 20.3182 64.8644 20.4145C64.7583 20.5108 64.6295 20.5589 64.4779 20.5589H60.4198V24.2757C60.4198 24.4133 60.3668 24.5302 60.2607 24.6265C60.1698 24.7228 60.0409 24.7709 59.8742 24.7709H57.9426ZM72.1764 24.7709C72.0249 24.7709 71.8961 24.7228 71.79 24.6265C71.6839 24.5302 71.6308 24.4133 71.6308 24.2757V20.5589H67.5727C67.4212 20.5589 67.2924 20.5108 67.1863 20.4145C67.0802 20.3182 67.0271 20.1944 67.0271 20.0431V18.357C67.0271 18.2057 67.0802 18.0888 67.1863 18.0063C67.2924 17.91 67.4212 17.8618 67.5727 17.8618H71.6308V14.2482C71.6308 14.1106 71.6839 13.9937 71.79 13.8974C71.8961 13.8011 72.0249 13.753 72.1764 13.753H74.1081C74.2748 13.753 74.4036 13.8011 74.4946 13.8974C74.6006 13.9937 74.6537 14.1106 74.6537 14.2482V17.8618H78.7118C78.8634 17.8618 78.9922 17.91 79.0983 18.0063C79.2044 18.0888 79.2574 18.2057 79.2574 18.357V20.0431C79.2574 20.1944 79.2044 20.3182 79.0983 20.4145C78.9922 20.5108 78.8634 20.5589 78.7118 20.5589H74.6537V24.2757C74.6537 24.4133 74.6006 24.5302 74.4946 24.6265C74.4036 24.7228 74.2748 24.7709 74.1081 24.7709H72.1764ZM25.4132 13.8179C26.5478 13.8179 27.4677 12.828 27.4677 11.6069C27.4677 10.3858 26.5478 9.39589 25.4132 9.39589C24.2785 9.39589 23.3587 10.3858 23.3587 11.6069C23.3587 12.828 24.2785 13.8179 25.4132 13.8179ZM24.3845 25.9648C24.2183 25.9648 24.0771 25.9078 23.9608 25.7938C23.9174 25.7513 23.8226 25.7054 23.7208 25.6561L23.7208 25.656L23.7207 25.656C23.5496 25.5731 23.3587 25.4806 23.3587 25.3785L23.6866 15.1919C23.6866 15.0589 23.7253 15.0236 23.8029 14.9531C23.8203 14.9373 23.8397 14.9197 23.861 14.8987C23.9774 14.7847 24.0438 14.7766 24.21 14.7766H26.4783C26.6611 14.7766 26.8273 14.7847 26.927 14.8987C27.0433 15.0127 27.0516 15.029 27.0516 15.1919L27.4677 25.3785C27.4677 25.481 27.2799 25.5738 27.1116 25.6569C27.0125 25.7059 26.9202 25.7515 26.8771 25.7938C26.7774 25.9078 26.6362 25.9648 26.4534 25.9648H24.3845ZM6.38075 10.3632C7.51542 10.3632 8.43525 9.37332 8.43525 8.15222C8.43525 6.93111 7.51542 5.94121 6.38075 5.94121C5.24608 5.94121 4.32625 6.93111 4.32625 8.15222C4.32625 9.37332 5.24608 10.3632 6.38075 10.3632ZM21.5841 8.63113C21.5841 9.85223 20.6643 10.8421 19.5296 10.8421C18.395 10.8421 17.4751 9.85223 17.4751 8.63113C17.4751 7.41003 18.395 6.42013 19.5296 6.42013C20.6643 6.42013 21.5841 7.41003 21.5841 8.63113ZM8.06426 25.973H5.09992C5.07057 25.973 4.98839 25.957 4.89447 25.8931C4.77707 25.8132 4.42488 25.4669 4.33683 25.2538C4.308 25.184 4.3421 23.9038 4.39246 22.0138C4.46512 19.2865 4.57162 15.2895 4.57162 11.8279L4.65967 11.6414L4.74772 11.5082L4.89447 11.4017L5.09992 11.2951H8.03491L8.26971 11.3484L8.38711 11.4283L8.53386 11.5882L8.59256 11.6414L8.65126 11.8279C8.65126 11.8279 8.90487 13.8258 8.84617 14.6782C8.78747 15.5307 17.3095 15.8503 17.3095 15.8503L17.2508 11.8279L17.3389 11.6681L17.4269 11.5349L17.5737 11.4017L17.7498 11.3218L17.9846 11.2951H20.6848L20.8902 11.3218L21.037 11.4017L21.1837 11.5082L21.3011 11.6681L21.3598 11.8279L21.5946 25.0673L21.4772 25.4402L21.3011 25.6533L21.2131 25.7599L21.037 25.8931L20.8902 25.9464L20.7728 25.973H17.9552L17.8085 25.9464L17.6617 25.8931L17.5443 25.8132L17.4269 25.7066L17.3682 25.6001L17.1628 25.4402L17.0454 25.0673L17.3095 18.1945C13.8455 17.3856 11.9456 17.3545 8.65126 18.1945C8.65126 19.6093 8.68795 20.6667 8.72464 21.7241C8.76132 22.7815 8.79801 23.8389 8.79801 25.2538L8.62191 25.5468L8.56321 25.6533L8.47516 25.7599L8.38711 25.8664L8.26971 25.9197L8.09361 25.973H8.06426Z"
            fill="white"
          />
        </svg>
      );
    case "job-section-jobLocation":
      return (
        <svg
          width="16"
          height="19"
          viewBox="0 0 16 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00004 9.66669C9.38075 9.66669 10.5 8.5474 10.5 7.16669C10.5 5.78598 9.38075 4.66669 8.00004 4.66669C6.61933 4.66669 5.50004 5.78598 5.50004 7.16669C5.50004 8.5474 6.61933 9.66669 8.00004 9.66669Z"
            stroke="#98A2B3"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.00004 17.5834C9.66671 14.25 14.6667 12.0986 14.6667 7.58335C14.6667 3.90146 11.6819 0.916687 8.00004 0.916687C4.31814 0.916687 1.33337 3.90146 1.33337 7.58335C1.33337 12.0986 6.33337 14.25 8.00004 17.5834Z"
            stroke="#98A2B3"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "job-section-jobType":
      return (
        <svg
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99996 4.25002V9.25002L13.3333 10.9167M18.3333 9.25002C18.3333 13.8524 14.6023 17.5834 9.99996 17.5834C5.39759 17.5834 1.66663 13.8524 1.66663 9.25002C1.66663 4.64765 5.39759 0.916687 9.99996 0.916687C14.6023 0.916687 18.3333 4.64765 18.3333 9.25002Z"
            stroke="#98A2B3"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "jobdrona-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 48 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.54984 17.8658L6.70368 16.0724L3.11685 15.7648L2.96301 17.5582L6.54984 17.8658ZM8.5612 23.9832L9.14365 22.28L8.5612 23.9832ZM12.7563 23.712L11.9965 22.0803L12.7563 23.712ZM17.5563 18.0006C17.5567 17.0065 16.7511 16.2003 15.757 16.2C14.7629 16.1996 13.9567 17.0052 13.9563 17.9994L17.5563 18.0006ZM5.5313 21.3928L7.07726 20.4708L5.5313 21.3928ZM8.5612 23.9832L7.97876 25.6863C9.89033 26.34 11.7313 26.175 13.5162 25.3438L12.7563 23.712L11.9965 22.0803C10.9811 22.5531 10.1019 22.6077 9.14365 22.28L8.5612 23.9832ZM12.7563 23.712L13.5162 25.3438C14.8373 24.7286 15.8333 23.5355 16.4833 22.2926C17.1469 21.0238 17.5558 19.5078 17.5563 18.0006L15.7563 18L13.9563 17.9994C13.956 18.8837 13.708 19.8312 13.2932 20.6242C12.865 21.4431 12.3614 21.9103 11.9965 22.0803L12.7563 23.712ZM4.75643 17.712C2.96301 17.5582 2.96297 17.5586 2.96293 17.5591C2.96292 17.5593 2.96288 17.5598 2.96285 17.5601C2.96279 17.5608 2.96273 17.5615 2.96267 17.5622C2.96255 17.5637 2.96241 17.5653 2.96227 17.567C2.96199 17.5705 2.96167 17.5745 2.96132 17.5791C2.96062 17.5881 2.95979 17.5992 2.95889 17.6123C2.95709 17.6385 2.95498 17.6727 2.95289 17.7141C2.94872 17.797 2.94464 17.9098 2.94348 18.0472C2.94119 18.3206 2.95044 18.699 2.99587 19.1381C3.0839 19.9888 3.32067 21.2002 3.98535 22.3147L5.5313 21.3928L7.07726 20.4708C6.78847 19.9866 6.6378 19.3576 6.57676 18.7676C6.54766 18.4863 6.54196 18.2444 6.54336 18.0774C6.54405 17.9946 6.54647 17.9322 6.54834 17.895C6.54928 17.8765 6.55006 17.8643 6.55042 17.8592C6.55059 17.8567 6.55066 17.8559 6.55057 17.857C6.55053 17.8575 6.55045 17.8585 6.55033 17.86C6.55027 17.8607 6.5502 17.8616 6.55012 17.8626C6.55008 17.863 6.55004 17.8636 6.54999 17.8641C6.54997 17.8644 6.54993 17.8648 6.54992 17.865C6.54988 17.8654 6.54984 17.8658 4.75643 17.712ZM5.5313 21.3928L3.98535 22.3147C5.01065 24.0339 6.24056 25.0919 7.97876 25.6863L8.5612 23.9832L9.14365 22.28C8.31503 21.9966 7.72445 21.556 7.07726 20.4708L5.5313 21.3928Z"
            fill="#EDC043"
          />
          <path
            d="M30.7568 21L30.7553 20.7841M30.7568 21C30.7568 24.9782 29.1765 28.7936 26.3634 31.6066C23.5504 34.4196 19.7351 36 15.7568 36V29.5M30.7568 21C30.7568 17.0218 29.1765 13.2064 26.3634 10.3934C23.5504 7.58035 19.7351 6 15.7568 6V18"
            stroke="#EDC043"
            stroke-width="3.6"
          />
          <path
            d="M31.7568 20C30.9284 20 30.2568 20.6716 30.2568 21.5C30.2568 22.3284 30.9284 23 31.7568 23V20ZM43.2568 21.5L44.4568 22.4L45.1318 21.5L44.4568 20.6L43.2568 21.5ZM39.9568 14.6L39.0568 13.4L36.6568 15.2L37.5568 16.4L39.9568 14.6ZM37.5568 26.6L36.6568 27.8L39.0568 29.6L39.9568 28.4L37.5568 26.6ZM31.7568 21.5V23H43.2568V21.5V20H31.7568V21.5ZM43.2568 21.5L44.4568 20.6L39.9568 14.6L38.7568 15.5L37.5568 16.4L42.0568 22.4L43.2568 21.5ZM43.2568 21.5L42.0568 20.6L37.5568 26.6L38.7568 27.5L39.9568 28.4L44.4568 22.4L43.2568 21.5Z"
            fill="#EDC043"
          />
        </svg>
      );
    case "placeholderPatterns":
      return (
        <svg
          // width="273"
          // height="408"
          width={width}
          height={height}
          viewBox="0 0 273 408"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <line
              x1="178.24"
              y1="12.7244"
              x2="182.5"
              y2="1.01986"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="204.864"
              y1="12.1777"
              x2="211.092"
              y2="1.39079"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="231.656"
              y1="11.6453"
              x2="239.662"
              y2="2.10368"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="258.65"
              y1="10.7437"
              x2="268.192"
              y2="2.73735"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="19.4605"
              y1="12.9309"
              x2="11.4542"
              y2="3.38926"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="46.0519"
              y1="13.1777"
              x2="39.8241"
              y2="2.39079"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="72.5291"
              y1="13.4084"
              x2="68.269"
              y2="1.7039"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="98.9371"
              y1="13.6297"
              x2="96.7742"
              y2="1.36324"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="125.324"
              y1="13.4561"
              x2="125.324"
              y2="1.00036"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="151.742"
              y1="13.2824"
              x2="153.905"
              y2="1.01594"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="150.217"
              y1="34.5222"
              x2="154.477"
              y2="22.8177"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="176.837"
              y1="33.9746"
              x2="183.065"
              y2="23.1877"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="203.628"
              y1="33.4431"
              x2="211.635"
              y2="23.9015"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="230.627"
              y1="32.5416"
              x2="240.168"
              y2="24.5352"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="257.859"
              y1="31.2736"
              x2="268.646"
              y2="25.0458"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="18.0285"
              y1="34.9746"
              x2="11.8007"
              y2="24.1877"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="44.5017"
              y1="35.2063"
              x2="40.2416"
              y2="23.5018"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="70.9097"
              y1="35.4266"
              x2="68.7468"
              y2="23.1601"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="97.2969"
              y1="35.2529"
              x2="97.2969"
              y2="22.7972"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="123.718"
              y1="35.0793"
              x2="125.881"
              y2="22.8128"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="122.189"
              y1="56.3201"
              x2="126.449"
              y2="44.6156"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="148.814"
              y1="55.7725"
              x2="155.042"
              y2="44.9855"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="175.605"
              y1="55.24"
              x2="183.611"
              y2="45.6984"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="202.603"
              y1="54.3384"
              x2="212.145"
              y2="46.3321"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="229.836"
              y1="53.0705"
              x2="240.623"
              y2="46.8427"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="257.33"
              y1="52.2185"
              x2="269.034"
              y2="47.9584"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="16.4783"
              y1="57.0041"
              x2="12.2182"
              y2="45.2996"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="42.8863"
              y1="57.2244"
              x2="40.7234"
              y2="44.958"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="69.2734"
              y1="57.0508"
              x2="69.2734"
              y2="44.5951"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="95.691"
              y1="56.8771"
              x2="97.8539"
              y2="44.6107"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="94.1658"
              y1="78.117"
              x2="98.4259"
              y2="66.4124"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="120.786"
              y1="77.5703"
              x2="127.014"
              y2="66.7834"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="147.578"
              y1="77.0379"
              x2="155.584"
              y2="67.4963"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="174.576"
              y1="76.1363"
              x2="184.118"
              y2="68.1299"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="201.812"
              y1="74.8683"
              x2="212.599"
              y2="68.6405"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="229.306"
              y1="74.0164"
              x2="241.011"
              y2="69.7563"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="257.08"
              y1="72.8033"
              x2="269.347"
              y2="70.6404"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="14.8589"
              y1="79.0223"
              x2="12.696"
              y2="66.7558"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="41.2461"
              y1="78.8486"
              x2="41.2461"
              y2="66.3929"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="67.6675"
              y1="78.675"
              x2="69.8304"
              y2="66.4085"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="66.1384"
              y1="99.9148"
              x2="70.3985"
              y2="88.2103"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="92.7629"
              y1="99.3672"
              x2="98.9907"
              y2="88.5802"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="119.554"
              y1="98.8357"
              x2="127.561"
              y2="89.2941"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="146.553"
              y1="97.9332"
              x2="156.094"
              y2="89.9268"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="173.785"
              y1="96.6662"
              x2="184.572"
              y2="90.4384"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="201.279"
              y1="95.8132"
              x2="212.984"
              y2="91.5531"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="229.053"
              y1="94.6011"
              x2="241.319"
              y2="92.4382"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="13.2227"
              y1="100.646"
              x2="13.2227"
              y2="88.1898"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="39.6402"
              y1="100.472"
              x2="41.8031"
              y2="88.2054"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="272.68"
              y1="95.418"
              x2="260.224"
              y2="95.418"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="38.115"
              y1="121.712"
              x2="42.3751"
              y2="110.007"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="64.7355"
              y1="121.165"
              x2="70.9634"
              y2="110.378"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="91.5269"
              y1="120.633"
              x2="99.5333"
              y2="111.091"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="118.525"
              y1="119.731"
              x2="128.067"
              y2="111.725"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="145.762"
              y1="118.463"
              x2="156.549"
              y2="112.235"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="173.256"
              y1="117.611"
              x2="184.96"
              y2="113.351"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="201.029"
              y1="116.398"
              x2="213.296"
              y2="114.235"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="11.6168"
              y1="122.27"
              x2="13.7797"
              y2="110.003"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="244.652"
              y1="117.216"
              x2="232.197"
              y2="117.216"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="272.365"
              y1="118.368"
              x2="260.099"
              y2="116.205"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="10.0877"
              y1="143.51"
              x2="14.3477"
              y2="131.805"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="36.7121"
              y1="142.962"
              x2="42.9399"
              y2="132.175"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="63.5035"
              y1="142.43"
              x2="71.5099"
              y2="132.889"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="90.5017"
              y1="141.529"
              x2="100.043"
              y2="133.523"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="117.734"
              y1="140.261"
              x2="128.521"
              y2="134.033"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="145.228"
              y1="139.409"
              x2="156.933"
              y2="135.149"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="173.002"
              y1="138.196"
              x2="185.269"
              y2="136.033"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="216.629"
              y1="139.013"
              x2="204.173"
              y2="139.013"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="244.338"
              y1="140.165"
              x2="232.072"
              y2="138.003"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="271.775"
              y1="141.288"
              x2="260.071"
              y2="137.028"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="8.68476"
              y1="164.76"
              x2="14.9126"
              y2="153.973"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="35.4761"
              y1="164.227"
              x2="43.4825"
              y2="154.686"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="62.4744"
              y1="163.326"
              x2="72.016"
              y2="155.319"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="89.7109"
              y1="162.058"
              x2="100.498"
              y2="155.83"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="117.205"
              y1="161.206"
              x2="128.909"
              y2="156.946"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="144.979"
              y1="159.994"
              x2="157.245"
              y2="157.831"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="270.93"
              y1="163.79"
              x2="260.143"
              y2="157.562"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="188.605"
              y1="160.811"
              x2="176.15"
              y2="160.811"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="216.315"
              y1="161.963"
              x2="204.048"
              y2="159.8"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="243.748"
              y1="163.085"
              x2="232.043"
              y2="158.825"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="7.45271"
              y1="186.025"
              x2="15.4591"
              y2="176.484"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="34.451"
              y1="185.124"
              x2="43.9926"
              y2="177.117"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="61.6836"
              y1="183.856"
              x2="72.4705"
              y2="177.628"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="89.1775"
              y1="183.004"
              x2="100.882"
              y2="178.744"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="116.951"
              y1="181.791"
              x2="129.218"
              y2="179.628"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="242.902"
              y1="185.588"
              x2="232.115"
              y2="179.36"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="269.853"
              y1="186.656"
              x2="260.312"
              y2="178.649"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="160.578"
              y1="182.607"
              x2="148.122"
              y2="182.607"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="188.287"
              y1="183.76"
              x2="176.021"
              y2="181.597"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="215.724"
              y1="184.883"
              x2="204.02"
              y2="180.623"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="6.42362"
              y1="206.92"
              x2="15.9652"
              y2="198.914"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="33.6602"
              y1="205.654"
              x2="44.4471"
              y2="199.426"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="61.1541"
              y1="204.802"
              x2="72.8586"
              y2="200.541"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="88.9279"
              y1="203.588"
              x2="101.194"
              y2="201.426"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="214.879"
              y1="207.386"
              x2="204.092"
              y2="201.158"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="241.826"
              y1="208.453"
              x2="232.284"
              y2="200.446"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="268.578"
              y1="209.109"
              x2="260.571"
              y2="199.567"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="132.555"
              y1="204.405"
              x2="120.099"
              y2="204.405"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="160.264"
              y1="205.558"
              x2="147.997"
              y2="203.395"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="187.701"
              y1="206.681"
              x2="175.996"
              y2="202.421"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="5.63281"
              y1="227.45"
              x2="16.4198"
              y2="221.223"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="33.1267"
              y1="226.598"
              x2="44.8313"
              y2="222.338"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="60.9006"
              y1="225.385"
              x2="73.167"
              y2="223.222"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="186.852"
              y1="229.182"
              x2="176.065"
              y2="222.955"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="213.803"
              y1="230.25"
              x2="204.261"
              y2="222.244"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="240.55"
              y1="230.905"
              x2="232.544"
              y2="221.364"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="267.146"
              y1="231.152"
              x2="260.918"
              y2="220.365"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="104.527"
              y1="226.203"
              x2="92.0716"
              y2="226.203"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="132.237"
              y1="227.355"
              x2="119.97"
              y2="225.192"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="159.674"
              y1="228.478"
              x2="147.969"
              y2="224.218"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="5.10329"
              y1="248.396"
              x2="16.8078"
              y2="244.136"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="32.8771"
              y1="247.183"
              x2="45.1436"
              y2="245.02"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="158.828"
              y1="250.98"
              x2="148.041"
              y2="244.752"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="185.775"
              y1="252.048"
              x2="176.234"
              y2="244.042"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="212.527"
              y1="252.703"
              x2="204.521"
              y2="243.162"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="239.118"
              y1="252.949"
              x2="232.891"
              y2="242.162"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="265.595"
              y1="253.181"
              x2="261.335"
              y2="241.476"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="76.5039"
              y1="248"
              x2="64.0482"
              y2="248"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="104.213"
              y1="249.153"
              x2="91.9466"
              y2="246.99"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="131.65"
              y1="250.276"
              x2="119.946"
              y2="246.016"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="4.84979"
              y1="268.981"
              x2="17.1163"
              y2="266.818"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="130.801"
              y1="272.778"
              x2="120.014"
              y2="266.55"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="157.752"
              y1="273.845"
              x2="148.21"
              y2="265.839"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="184.503"
              y1="274.5"
              x2="176.497"
              y2="264.959"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="211.095"
              y1="274.747"
              x2="204.867"
              y2="263.96"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="237.568"
              y1="274.979"
              x2="233.308"
              y2="263.274"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="263.976"
              y1="275.199"
              x2="261.813"
              y2="262.933"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="48.4766"
              y1="269.798"
              x2="36.0209"
              y2="269.798"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="76.1857"
              y1="270.951"
              x2="63.9193"
              y2="268.788"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="103.623"
              y1="272.073"
              x2="91.9183"
              y2="267.812"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="102.777"
              y1="294.575"
              x2="91.9904"
              y2="288.347"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="129.724"
              y1="295.643"
              x2="120.183"
              y2="287.637"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="156.476"
              y1="296.298"
              x2="148.47"
              y2="286.756"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="183.068"
              y1="296.545"
              x2="176.84"
              y2="285.758"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="209.545"
              y1="296.776"
              x2="205.285"
              y2="285.071"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="235.953"
              y1="296.997"
              x2="233.79"
              y2="284.73"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="262.34"
              y1="296.823"
              x2="262.34"
              y2="284.368"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="20.4531"
              y1="291.595"
              x2="7.99743"
              y2="291.595"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="48.1623"
              y1="292.748"
              x2="35.8958"
              y2="290.585"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="75.5994"
              y1="293.87"
              x2="63.8949"
              y2="289.61"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="74.75"
              y1="316.373"
              x2="63.9631"
              y2="310.145"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="101.701"
              y1="317.44"
              x2="92.1593"
              y2="309.434"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="128.453"
              y1="318.096"
              x2="120.446"
              y2="308.554"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="155.044"
              y1="318.342"
              x2="148.816"
              y2="307.555"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="181.517"
              y1="318.573"
              x2="177.257"
              y2="306.869"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="207.925"
              y1="318.794"
              x2="205.762"
              y2="306.527"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="234.312"
              y1="318.62"
              x2="234.312"
              y2="306.164"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="260.734"
              y1="318.446"
              x2="262.897"
              y2="306.18"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="20.1349"
              y1="314.545"
              x2="7.86848"
              y2="312.382"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="47.572"
              y1="315.668"
              x2="35.8675"
              y2="311.408"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="259.205"
              y1="339.686"
              x2="263.465"
              y2="327.982"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="46.7266"
              y1="338.17"
              x2="35.9396"
              y2="331.942"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="73.6736"
              y1="339.238"
              x2="64.132"
              y2="331.231"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="100.425"
              y1="339.893"
              x2="92.419"
              y2="330.351"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="127.017"
              y1="340.14"
              x2="120.789"
              y2="329.353"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="153.494"
              y1="340.37"
              x2="149.234"
              y2="328.666"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="179.902"
              y1="340.592"
              x2="177.739"
              y2="328.325"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="206.289"
              y1="340.418"
              x2="206.289"
              y2="327.962"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="232.707"
              y1="340.244"
              x2="234.87"
              y2="327.978"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="19.5486"
              y1="337.465"
              x2="7.84408"
              y2="333.205"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="231.181"
              y1="361.484"
              x2="235.441"
              y2="349.78"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="257.802"
              y1="360.937"
              x2="264.03"
              y2="350.15"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="18.6992"
              y1="359.968"
              x2="7.91227"
              y2="353.74"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="45.6502"
              y1="361.036"
              x2="36.1086"
              y2="353.029"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="72.4019"
              y1="361.691"
              x2="64.3956"
              y2="352.149"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="98.9933"
              y1="361.937"
              x2="92.7655"
              y2="351.15"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="125.467"
              y1="362.168"
              x2="121.206"
              y2="350.464"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="151.875"
              y1="362.389"
              x2="149.712"
              y2="350.123"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="178.262"
              y1="362.216"
              x2="178.262"
              y2="349.76"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="204.683"
              y1="362.042"
              x2="206.846"
              y2="349.776"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="203.154"
              y1="383.282"
              x2="207.414"
              y2="371.577"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="229.779"
              y1="382.734"
              x2="236.006"
              y2="371.947"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="256.57"
              y1="382.202"
              x2="264.576"
              y2="372.66"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="17.6228"
              y1="382.832"
              x2="8.08122"
              y2="374.826"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="44.3746"
              y1="383.488"
              x2="36.3682"
              y2="373.946"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="70.966"
              y1="383.734"
              x2="64.7382"
              y2="372.947"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="97.4431"
              y1="383.966"
              x2="93.183"
              y2="372.262"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="123.851"
              y1="384.186"
              x2="121.688"
              y2="371.92"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="150.238"
              y1="384.013"
              x2="150.238"
              y2="371.557"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="176.656"
              y1="383.839"
              x2="178.819"
              y2="371.573"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="175.131"
              y1="405.079"
              x2="179.391"
              y2="393.374"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="201.751"
              y1="404.532"
              x2="207.979"
              y2="393.745"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="228.543"
              y1="404"
              x2="236.549"
              y2="394.458"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="255.541"
              y1="403.098"
              x2="265.082"
              y2="395.092"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="16.3511"
              y1="405.285"
              x2="8.34478"
              y2="395.744"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="42.9426"
              y1="405.532"
              x2="36.7147"
              y2="394.745"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="69.4158"
              y1="405.763"
              x2="65.1557"
              y2="394.058"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="95.8238"
              y1="405.984"
              x2="93.6609"
              y2="393.718"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="122.211"
              y1="405.811"
              x2="122.211"
              y2="393.355"
              stroke="#2888F6"
              stroke-width="2"
            />
            <line
              x1="148.632"
              y1="405.637"
              x2="150.795"
              y2="393.37"
              stroke="#2888F6"
              stroke-width="2"
            />
          </g>
        </svg>
      );
    case "forgotPassSvg":
      return (
        <svg
          // width="98"
          // height="99"
          width={width}
          height={height}
          viewBox="0 0 98 99"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.33594 33.9597C5.33594 18.4958 17.872 5.95972 33.3359 5.95972H64.6641C80.1281 5.95972 92.6641 18.4957 92.6641 33.9597V65.2879C92.6641 80.7518 80.1281 93.2879 64.6641 93.2879H33.3359C17.872 93.2879 5.33594 80.7518 5.33594 65.2879V33.9597Z"
            fill="#D4E7FD"
          />
          <path
            d="M55.3677 41.4368L61.7354 35.0691M65.3741 31.4304L61.7354 35.0691L65.3741 31.4304ZM47.8902 48.9142C48.8296 49.8411 49.5764 50.9447 50.0876 52.1614C50.5987 53.3781 50.8641 54.6838 50.8685 56.0035C50.873 57.3232 50.6163 58.6307 50.1133 59.8508C49.6103 61.0709 48.871 62.1794 47.9378 63.1126C47.0046 64.0458 45.8961 64.7851 44.676 65.2881C43.4559 65.7911 42.1484 66.0478 40.8287 66.0433C39.509 66.0389 38.2033 65.7735 36.9866 65.2624C35.7699 64.7512 34.6663 64.0044 33.7394 63.065C31.9167 61.1778 30.9081 58.6502 30.9309 56.0266C30.9537 53.4029 32.0061 50.8932 33.8613 49.038C35.7166 47.1827 38.2263 46.1303 40.8499 46.1075C43.4736 46.0847 46.0012 47.0933 47.8884 48.9161L47.8902 48.9142ZM47.8902 48.9142L55.3677 41.4368L47.8902 48.9142ZM55.3677 41.4368L60.8257 46.8948L67.1934 40.5271L61.7354 35.0691L55.3677 41.4368Z"
            stroke="#206DC5"
            stroke-width="3.63867"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M33.3359 10.9597H64.6641V0.959717H33.3359V10.9597ZM87.6641 33.9597V65.2879H97.6641V33.9597H87.6641ZM64.6641 88.2879H33.3359V98.2879H64.6641V88.2879ZM10.3359 65.2879V33.9597H0.335938V65.2879H10.3359ZM33.3359 88.2879C20.6334 88.2879 10.3359 77.9904 10.3359 65.2879H0.335938C0.335938 83.5133 15.1106 98.2879 33.3359 98.2879V88.2879ZM87.6641 65.2879C87.6641 77.9904 77.3666 88.2879 64.6641 88.2879V98.2879C82.8895 98.2879 97.6641 83.5133 97.6641 65.2879H87.6641ZM64.6641 10.9597C77.3666 10.9597 87.6641 21.2572 87.6641 33.9597H97.6641C97.6641 15.7343 82.8895 0.959717 64.6641 0.959717V10.9597ZM33.3359 0.959717C15.1105 0.959717 0.335938 15.7343 0.335938 33.9597H10.3359C10.3359 21.2572 20.6334 10.9597 33.3359 10.9597V0.959717Z"
            fill="#EAF3FE"
          />
        </svg>
      );
    case "logout":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.3333 13.1667L16.5 9M16.5 9L12.3333 4.83333M16.5 9H6.5M6.5 1.5H5.5C4.09987 1.5 3.3998 1.5 2.86502 1.77248C2.39462 2.01217 2.01217 2.39462 1.77248 2.86502C1.5 3.3998 1.5 4.09987 1.5 5.5V12.5C1.5 13.9001 1.5 14.6002 1.77248 15.135C2.01217 15.6054 2.39462 15.9878 2.86502 16.2275C3.3998 16.5 4.09987 16.5 5.5 16.5H6.5"
            stroke="#475467"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );

    case "drawer-dashboard-logo":
      return (
        <svg
          width={24}
          height={24}
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.33333 20.6517V14.0739C9.33333 13.5761 9.33333 13.3272 9.43022 13.137C9.51544 12.9698 9.65142 12.8338 9.81868 12.7486C10.0088 12.6517 10.2577 12.6517 10.7556 12.6517H13.2444C13.7423 12.6517 13.9912 12.6517 14.1813 12.7486C14.3486 12.8338 14.4846 12.9698 14.5698 13.137C14.6667 13.3272 14.6667 13.5761 14.6667 14.0739V20.6517M11.1268 4.44191L5.09812 9.13092C4.69513 9.44436 4.49363 9.60108 4.34847 9.79734C4.21988 9.9712 4.12409 10.1671 4.0658 10.3753C4 10.6104 4 10.8656 4 11.3762V17.8072C4 18.8029 4 19.3007 4.19377 19.681C4.36421 20.0155 4.63617 20.2875 4.97068 20.4579C5.35097 20.6517 5.8488 20.6517 6.84444 20.6517H17.1556C18.1512 20.6517 18.649 20.6517 19.0293 20.4579C19.3638 20.2875 19.6358 20.0155 19.8062 19.681C20 19.3007 20 18.8029 20 17.8072V11.3762C20 10.8656 20 10.6104 19.9342 10.3753C19.8759 10.1671 19.7801 9.9712 19.6515 9.79734C19.5064 9.60108 19.3049 9.44436 18.9019 9.13092L12.8732 4.44191C12.5609 4.19902 12.4047 4.07758 12.2323 4.03089C12.0802 3.9897 11.9198 3.9897 11.7677 4.03089C11.5953 4.07758 11.4391 4.19902 11.1268 4.44191Z"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "drawer-preparation-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 18.1523L9.91663 18.0273C9.33776 17.159 9.04832 16.7248 8.66592 16.4105C8.32739 16.1323 7.93731 15.9235 7.51801 15.7962C7.04438 15.6523 6.52259 15.6523 5.47902 15.6523H4.33334C3.39992 15.6523 2.93321 15.6523 2.57669 15.4707C2.26308 15.3109 2.00812 15.0559 1.84833 14.7423C1.66667 14.3858 1.66667 13.9191 1.66667 12.9857V5.81901C1.66667 4.88559 1.66667 4.41888 1.84833 4.06236C2.00812 3.74876 2.26308 3.49379 2.57669 3.334C2.93321 3.15234 3.39992 3.15234 4.33334 3.15234H4.66667C6.53351 3.15234 7.46693 3.15234 8.17997 3.51566C8.80718 3.83523 9.31712 4.34517 9.63669 4.97238C10 5.68541 10 6.61884 10 8.48568M10 18.1523V8.48568M10 18.1523L10.0834 18.0273C10.6623 17.159 10.9517 16.7248 11.3341 16.4105C11.6726 16.1323 12.0627 15.9235 12.482 15.7962C12.9556 15.6523 13.4774 15.6523 14.521 15.6523H15.6667C16.6001 15.6523 17.0668 15.6523 17.4233 15.4707C17.7369 15.3109 17.9919 15.0559 18.1517 14.7423C18.3333 14.3858 18.3333 13.9191 18.3333 12.9857V5.81901C18.3333 4.88559 18.3333 4.41888 18.1517 4.06236C17.9919 3.74876 17.7369 3.49379 17.4233 3.334C17.0668 3.15234 16.6001 3.15234 15.6667 3.15234H15.3333C13.4665 3.15234 12.5331 3.15234 11.82 3.51566C11.1928 3.83523 10.6829 4.34517 10.3633 4.97238C10 5.68541 10 6.61884 10 8.48568"
            stroke={color || "#EDC043"}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "drawer-test-logo":
      return (
        <svg
          width={width || "20"}
          height={height || "20"}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99999 17.3186H17.5M2.50002 17.3185H3.89547C4.30312 17.3185 4.50694 17.3185 4.69876 17.2725C4.86882 17.2317 5.03139 17.1643 5.18051 17.0729C5.34871 16.9699 5.49283 16.8258 5.78109 16.5375L16.25 6.06855C16.9404 5.37819 16.9404 4.2589 16.25 3.56855C15.5597 2.87819 14.4404 2.87819 13.75 3.56855L3.28107 14.0375C2.99281 14.3258 2.84869 14.4699 2.74562 14.6381C2.65423 14.7872 2.58689 14.9498 2.54607 15.1198C2.50002 15.3116 2.50002 15.5155 2.50002 15.9231V17.3185Z"
            stroke={color || "#F2F4F7"}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "drawer-mock-interview-logo":
      return (
        <svg
          width={width || "20"}
          height={height || "20"}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.1 18.7531H13.9M10.5 15.3531V18.7531M6.08 15.3531H14.92C16.3481 15.3531 17.0622 15.3531 17.6077 15.0752C18.0875 14.8307 18.4776 14.4406 18.7221 13.9608C19 13.4153 19 12.7013 19 11.2731V7.53312C19 6.10499 19 5.39092 18.7221 4.84545C18.4776 4.36564 18.0875 3.97554 17.6077 3.73106C17.0622 3.45312 16.3481 3.45312 14.92 3.45312H6.08C4.65187 3.45312 3.9378 3.45312 3.39232 3.73106C2.91251 3.97554 2.52241 4.36564 2.27793 4.84545C2 5.39092 2 6.10499 2 7.53313V11.2731C2 12.7013 2 13.4153 2.27793 13.9608C2.52241 14.4406 2.91251 14.8307 3.39232 15.0752C3.9378 15.3531 4.65187 15.3531 6.08 15.3531Z"
            stroke={color || "#F2F4F7"}
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.25 14.0336C7.35301 12.8637 8.85054 12.1447 10.5 12.1447C12.1495 12.1447 13.647 12.8637 14.75 14.0336M12.625 8.13086C12.625 9.30446 11.6736 10.2559 10.5 10.2559C9.32639 10.2559 8.375 9.30446 8.375 8.13086C8.375 6.95725 9.32639 6.00586 10.5 6.00586C11.6736 6.00586 12.625 6.95725 12.625 8.13086Z"
            stroke={color || "#F2F4F7"}
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "drawer-cv-optimizer-logo":
      return (
        <svg
          width={width || "20"}
          height={height || "20"}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.6667 9.81836H6.66666M8.33333 13.1517H6.66666M13.3333 6.48503H6.66666M16.6667 9.40169V6.31836C16.6667 4.91823 16.6667 4.21816 16.3942 3.68338C16.1545 3.21298 15.772 2.83053 15.3016 2.59084C14.7669 2.31836 14.0668 2.31836 12.6667 2.31836H7.33333C5.9332 2.31836 5.23313 2.31836 4.69835 2.59084C4.22795 2.83053 3.8455 3.21298 3.60581 3.68338C3.33333 4.21816 3.33333 4.91823 3.33333 6.31836V14.985C3.33333 16.3852 3.33333 17.0852 3.60581 17.62C3.8455 18.0904 4.22795 18.4729 4.69835 18.7125C5.23313 18.985 5.9332 18.985 7.33333 18.985H9.58333M18.3333 18.985L17.0833 17.735M17.9167 15.6517C17.9167 17.2625 16.6108 18.5684 15 18.5684C13.3892 18.5684 12.0833 17.2625 12.0833 15.6517C12.0833 14.0409 13.3892 12.735 15 12.735C16.6108 12.735 17.9167 14.0409 17.9167 15.6517Z"
            stroke={color || "#F4F4F4"}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "drawer-insights-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_134_2900)">
            <path
              d="M17.6752 13.3875C17.145 14.6412 16.3158 15.746 15.2601 16.6053C14.2043 17.4645 12.9541 18.052 11.6189 18.3165C10.2836 18.5809 8.90386 18.5143 7.6003 18.1223C6.29673 17.7304 5.10903 17.0251 4.14102 16.068C3.17302 15.111 2.45419 13.9315 2.04737 12.6325C1.64055 11.3335 1.55814 9.95457 1.80734 8.61636C2.05653 7.27815 2.62975 6.02136 3.47688 4.95586C4.324 3.89036 5.41924 3.0486 6.66684 2.50417M18.3335 10.1458C18.3335 9.05148 18.118 7.96785 17.6992 6.9568C17.2804 5.94576 16.6666 5.0271 15.8927 4.25328C15.1189 3.47946 14.2002 2.86563 13.1892 2.44684C12.1782 2.02805 11.0945 1.8125 10.0002 1.8125V10.1458H18.3335Z"
              stroke={color}
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_134_2900">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0 0.148438)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "drawer-jobs-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6 4.64688C13.6 3.8099 13.6 3.39141 13.508 3.04806C13.2583 2.11632 12.5306 1.38854 11.5988 1.13888C11.2555 1.04688 10.837 1.04688 10 1.04688C9.16303 1.04688 8.74454 1.04688 8.40119 1.13888C7.46944 1.38854 6.74166 2.11632 6.492 3.04806C6.4 3.39141 6.4 3.8099 6.4 4.64688M3.88 17.2469H16.12C17.1281 17.2469 17.6321 17.2469 18.0172 17.0507C18.3559 16.8781 18.6312 16.6028 18.8038 16.2641C19 15.879 19 15.375 19 14.3669V7.52688C19 6.51878 19 6.01473 18.8038 5.62969C18.6312 5.291 18.3559 5.01564 18.0172 4.84306C17.6321 4.64688 17.1281 4.64688 16.12 4.64688H3.88C2.87191 4.64688 2.36786 4.64688 1.98282 4.84306C1.64413 5.01564 1.36876 5.291 1.19619 5.62969C1 6.01473 1 6.51878 1 7.52688V14.3669C1 15.375 1 15.879 1.19619 16.2641C1.36876 16.6028 1.64413 16.8781 1.98282 17.0507C2.36786 17.2469 2.87191 17.2469 3.88 17.2469Z"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "drawer-settings-logo":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "preparation-modal-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 52 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_dii_195_2637)">
            <path
              d="M2 11C2 5.47715 6.47715 1 12 1H40C45.5229 1 50 5.47715 50 11V39C50 44.5229 45.5228 49 40 49H12C6.47715 49 2 44.5228 2 39V11Z"
              fill="#FCFCFD"
            />
            <path
              d="M2.5 11C2.5 5.75329 6.75329 1.5 12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.75329 48.5 2.5 44.2467 2.5 39V11Z"
              stroke="#EAECF0"
            />
            <path
              d="M28.0914 19.7222H34.0451C34.5173 19.7222 34.7534 19.7222 34.8914 19.8215C35.0119 19.9081 35.0903 20.0414 35.1075 20.1888C35.1272 20.3577 35.0126 20.564 34.7833 20.9768L33.3624 23.5343C33.2793 23.684 33.2377 23.7589 33.2214 23.8381C33.207 23.9083 33.207 23.9806 33.2214 24.0508C33.2377 24.13 33.2793 24.2049 33.3624 24.3545L34.7833 26.9121C35.0126 27.3248 35.1272 27.5312 35.1075 27.7001C35.0903 27.8475 35.0119 27.9808 34.8914 28.0674C34.7534 28.1667 34.5173 28.1667 34.0451 28.1667H26.6136C26.0224 28.1667 25.7269 28.1667 25.5011 28.0516C25.3024 27.9504 25.141 27.7889 25.0398 27.5903C24.9247 27.3645 24.9247 27.0689 24.9247 26.4778V23.9444M21.2303 34.5L17.0081 17.6111M18.5914 23.9444H26.4025C26.9937 23.9444 27.2892 23.9444 27.515 23.8294C27.7137 23.7282 27.8751 23.5667 27.9763 23.3681C28.0914 23.1423 28.0914 22.8467 28.0914 22.2556V17.1889C28.0914 16.5977 28.0914 16.3021 27.9763 16.0763C27.8751 15.8777 27.7137 15.7162 27.515 15.615C27.2892 15.5 26.9937 15.5 26.4025 15.5H18.6433C17.906 15.5 17.5374 15.5 17.2852 15.6528C17.0642 15.7867 16.9 15.997 16.8237 16.2439C16.7366 16.5256 16.8261 16.8832 17.0049 17.5985L18.5914 23.9444Z"
              stroke="#101828"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_dii_195_2637"
              x="0"
              y="0"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_195_2637"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_195_2637"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="-2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_195_2637"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="1"
                operator="erode"
                in="SourceAlpha"
                result="effect3_innerShadow_195_2637"
              />
              <feOffset />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
              />
              <feBlend
                mode="normal"
                in2="effect2_innerShadow_195_2637"
                result="effect3_innerShadow_195_2637"
              />
            </filter>
          </defs>
        </svg>
      );
    case "preparation-guide-external-link-icon":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 12L12 4M12 4H4M12 4V12"
            stroke={color || "#206DC5"}
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "preparation-logo":
      return (
        <svg
          width="19"
          height="19"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 18.0999L9.90995 17.9648C9.28477 17.0271 8.97218 16.5582 8.55919 16.2187C8.19357 15.9182 7.77229 15.6928 7.31944 15.5552C6.80793 15.3999 6.2444 15.3999 5.11734 15.3999H3.88C2.87191 15.3999 2.36786 15.3999 1.98282 15.2037C1.64413 15.0311 1.36876 14.7558 1.19619 14.4171C1 14.032 1 13.528 1 12.5199V4.7799C1 3.77181 1 3.26776 1.19619 2.88272C1.36876 2.54403 1.64413 2.26866 1.98282 2.09609C2.36786 1.8999 2.87191 1.8999 3.88 1.8999H4.24C6.25619 1.8999 7.26428 1.8999 8.03437 2.29228C8.71175 2.63742 9.26248 3.18815 9.60762 3.86554C10 4.63562 10 5.64371 10 7.6599M10 18.0999V7.6599M10 18.0999L10.09 17.9648C10.7152 17.0271 11.0278 16.5582 11.4408 16.2187C11.8064 15.9182 12.2277 15.6928 12.6806 15.5552C13.1921 15.3999 13.7556 15.3999 14.8827 15.3999H16.12C17.1281 15.3999 17.6321 15.3999 18.0172 15.2037C18.3559 15.0311 18.6312 14.7558 18.8038 14.4171C19 14.032 19 13.528 19 12.5199V4.7799C19 3.77181 19 3.26776 18.8038 2.88272C18.6312 2.54403 18.3559 2.26866 18.0172 2.09609C17.6321 1.8999 17.1281 1.8999 16.12 1.8999H15.76C13.7438 1.8999 12.7357 1.8999 11.9656 2.29228C11.2883 2.63742 10.7375 3.18815 10.3924 3.86554C10 4.63562 10 5.64371 10 7.6599"
            stroke="#0F1B23"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "mock-test-logo":
      return (
        <svg
          width="19"
          height="19"
          viewBox="0 0 18 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.0588 10.8824V5.51765C16.0588 3.93632 16.0588 3.14566 15.7511 2.54167C15.4804 2.01039 15.0484 1.57845 14.5172 1.30775C13.9132 1 13.1225 1 11.5412 1H5.51765C3.93632 1 3.14566 1 2.54167 1.30775C2.01039 1.57845 1.57845 2.01039 1.30775 2.54167C1 3.14566 1 3.93632 1 5.51765V15.3059C1 16.8872 1 17.6779 1.30775 18.2819C1.57845 18.8131 2.01039 19.2451 2.54167 19.5158C3.14566 19.8235 3.93632 19.8235 5.51765 19.8235H8.52941M10.4118 9.47059H4.76471M6.64706 13.2353H4.76471M12.2941 5.70588H4.76471M10.8824 17L12.7647 18.8824L17 14.6471"
            stroke="#0F1B23"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "right-arrow":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 7H13M13 7L7 1M13 7L7 13"
            stroke={color || "#475467"}
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "search-icon":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
            stroke="#475467"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "magic-icon":
      return (
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 17V13M3.5 5V1M1.5 3H5.5M1.5 15H5.5M10.3 1.8L8.91266 5.40709C8.68705 5.99367 8.57424 6.28697 8.39882 6.53367C8.24335 6.75232 8.05232 6.94335 7.83367 7.09882C7.58697 7.27424 7.29367 7.38705 6.70709 7.61266L3.1 9L6.70709 10.3873C7.29367 10.613 7.58697 10.7258 7.83367 10.9012C8.05232 11.0566 8.24335 11.2477 8.39882 11.4663C8.57424 11.713 8.68705 12.0063 8.91266 12.5929L10.3 16.2L11.6873 12.5929C11.913 12.0063 12.0258 11.713 12.2012 11.4663C12.3566 11.2477 12.5477 11.0566 12.7663 10.9012C13.013 10.7258 13.3063 10.613 13.8929 10.3873L17.5 9L13.8929 7.61266C13.3063 7.38705 13.013 7.27424 12.7663 7.09882C12.5477 6.94335 12.3566 6.75232 12.2012 6.53367C12.0258 6.28697 11.913 5.99367 11.6873 5.40709L10.3 1.8Z"
            stroke={color || "#FCFCFD"}
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "upload-file-icon":
      return (
        <svg
          width="45"
          height="44"
          viewBox="0 0 45 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_dii_348_2130)">
            <path
              d="M2.5 9C2.5 4.58172 6.08172 1 10.5 1H34.5C38.9183 1 42.5 4.58172 42.5 9V33C42.5 37.4183 38.9183 41 34.5 41H10.5C6.08172 41 2.5 37.4183 2.5 33V9Z"
              fill="#FCFCFD"
            />
            <path
              d="M10.5 1.5H34.5C38.6421 1.5 42 4.85786 42 9V33C42 37.1421 38.6421 40.5 34.5 40.5H10.5C6.35786 40.5 3 37.1421 3 33V9C3 4.85786 6.35786 1.5 10.5 1.5Z"
              stroke="#D0D5DD"
            />
            <path
              d="M19.1667 24.3333L22.5 21M22.5 21L25.8334 24.3333M22.5 21V28.5M29.1667 24.9524C30.1846 24.1117 30.8334 22.8399 30.8334 21.4167C30.8334 18.8854 28.7813 16.8333 26.25 16.8333C26.0679 16.8333 25.8976 16.7383 25.8051 16.5814C24.7184 14.7374 22.712 13.5 20.4167 13.5C16.9649 13.5 14.1667 16.2982 14.1667 19.75C14.1667 21.4718 14.8629 23.0309 15.9891 24.1613"
              stroke="#101828"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_dii_348_2130"
              x="0.5"
              y="0"
              width="44"
              height="44"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_348_2130"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_348_2130"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="-2" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect2_innerShadow_348_2130"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="1"
                operator="erode"
                in="SourceAlpha"
                result="effect3_innerShadow_348_2130"
              />
              <feOffset />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
              />
              <feBlend
                mode="normal"
                in2="effect2_innerShadow_348_2130"
                result="effect3_innerShadow_348_2130"
              />
            </filter>
          </defs>
        </svg>
      );
    case "check-icon":
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="8" fill="#206DC5" />
          <path
            d="M12 5L6.5 10.5L4 8"
            stroke="white"
            stroke-width="1.6666"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "left-arrow-icon":
      return (
        <svg
          fill="#000000"
          version="1.1"
          id="Capa_1"
          width="22"
          viewBox="0 0 400.004 400.004"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z"></path>{" "}
            </g>{" "}
          </g>
        </svg>
      );

    default:
      break;
  }
}

export default Icon;
